import { render } from "./ViewUpdateDetails.vue?vue&type=template&id=24cd67f5&scoped=true"
import script from "./ViewUpdateDetails.vue?vue&type=script&lang=js"
export * from "./ViewUpdateDetails.vue?vue&type=script&lang=js"

import "./ViewUpdateDetails.vue?vue&type=style&index=0&id=24cd67f5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24cd67f5"]])

export default __exports__